export function opendns(){
    if (typeof document === "undefined") return;
    location.href = "/securitys/blocks/opendns";
}